import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Avatar, Typography, Divider, Theme } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { getUserInfo } from 'store/slices/userInfoSlice';

const useStyles = makeStyles((theme: Theme) => ({
    root: {},
    details: {
        display: 'flex',
    },
    avatar: {
        marginLeft: 'auto',
        height: 110,
        width: 100,
        flexShrink: 0,
        flexGrow: 0,
    },
    progress: {
        marginTop: theme.spacing(2),
    },
    uploadButton: {
        marginRight: theme.spacing(2),
    },
}));

const AccountProfile = (props: any) => {
    const { className, ...rest } = props;
    const currentUser = useSelector(getUserInfo);

    const classes = useStyles();

    const user = {
        name: currentUser.fullName,
        city: currentUser.region?.description,
        timezone: 'GTM+6',
        avatar: '/images/avatars/avatar_11.png',
    };

    return (
        <Card {...rest} className={clsx(classes.root, className)}>
            <CardContent>
                <div className={classes.details}>
                    <div>
                        <Typography gutterBottom variant="h2">
                            {user.name}
                        </Typography>
                        <Typography color="textSecondary" variant="body1">
                            {user.city}
                        </Typography>
                        <Typography color="textSecondary" variant="body1">
                            {moment().format('hh:mm A')} ({user.timezone})
                        </Typography>
                    </div>
                    <Avatar className={classes.avatar} src={user.avatar} />
                </div>
            </CardContent>
            <Divider />
        </Card>
    );
};

AccountProfile.propTypes = {
    className: PropTypes.string,
};

export default AccountProfile;
